import React from "react"
import Back from "../common/back/Back"
import "./team.css"
import "../about/about.css"
import { team } from "../../dummydata"

const Team = () => {
  return (
    <>
      <Back title='Our Team' />
      
      {/* Hero Section */}
      <section className='team-hero'>
        <div className="container">
          <div className="team-hero-content">
            <h1>Meet Our Exceptional Team</h1>
            <p>Dedicated professionals committed to excellence in education and innovation</p>
          </div>
        </div>
      </section>

      {/* Team Members Section */}
      <section className='team-section padding'>
        <div className="container">
          <div className="section-header">
            <h2>Leadership & Faculty</h2>
            <p>Our team brings together decades of experience in education, technology, and industry to provide you with the best learning experience possible.</p>
          </div>
          
          <div className="team-grid">
            {team.map((member, index) => (
              <div key={index} className="team-card">
                <div className="member-photo">
                  <img src={member.cover} alt={member.name} />
                  <div className="photo-overlay">
                    <div className="social-links">
                      <a href="#" className="social-link">
                        <i className="fab fa-linkedin"></i>
                      </a>
                      <a href="#" className="social-link">
                        <i className="fab fa-twitter"></i>
                      </a>
                      <a href="#" className="social-link">
                        <i className="fab fa-github"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="member-info">
                  <h3>{member.name}</h3>
                  <p className="position">{member.work}</p>
                  <p className="bio">Passionate educator with expertise in modern teaching methodologies and industry best practices.</p>
                  
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className='team-values'>
        <div className="container">
          <div className="section-header">
            <h2>Our Core Values</h2>
            <p>The principles that guide our team and shape our educational approach</p>
          </div>
          
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-lightbulb"></i>
              </div>
              <h3>Innovation</h3>
              <p>Constantly exploring new teaching methods and technologies to enhance learning outcomes.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-users"></i>
              </div>
              <h3>Collaboration</h3>
              <p>Working together as a team to create the best possible learning environment for our students.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-star"></i>
              </div>
              <h3>Excellence</h3>
              <p>Maintaining the highest standards in everything we do, from curriculum design to student support.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-heart"></i>
              </div>
              <h3>Passion</h3>
              <p>Genuine enthusiasm for education and helping students achieve their goals and dreams.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className='team-cta'>
        <div className="container">
          <div className="cta-content">
            <h2>Join Our Team</h2>
            <p>Are you passionate about education and innovation? We're always looking for talented individuals to join our team.</p>
            <div className="cta-buttons">
              <a href="/contact" className="btn-primary">Get in Touch</a>
              <a href="/careers" className="btn-secondary">View Opportunities</a>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Team
